import React from 'react';
import * as TotemActions from '../actions/TotemActions';
import TotemStore from '../stores/TotemStore';

class ArticleItemComponent extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            hasPromo: this.props.article.hasPromo
        };
    }

    componentWillMount() {
        TotemStore.on('ARTICLE_DELETED', this.props.onArticleDeleted);
    }

    componentDidMount() {
        //$('.tooltipped').tooltip({ delay: 10 });
    }

    _handleDeleteItem() {
        TotemActions.deleteItem(this.props.article.id);
    }

    _handleTogglePromo() {
        TotemActions.togglePromo(this.props.article.id, this.state.hasPromo, this.togglePromoCallback.bind(this));
    }

    togglePromoCallback(succeded) {
        this.setState({
            hasPromo: succeded
        });
    }

    render() {
                    /*<i className="fa fa-bar-chart item-action tooltipped" data-position="top" data-tooltip="Estadísticas" onClick={this._handleEditItem.bind(this)} />
                    <i className="fa fa-pencil item-action tooltipped" data-position="top" data-tooltip="Editar" onClick={this._handleEditItem.bind(this)} />*/
        return (
            <tr>
                <td>
                    <a href={this.props.article.linkUrl} target="_blank" >{this.props.article.name}</a>
                </td>
                <td>
                    <span>{this.props.article.currency + ' ' + this.props.article.price}</span>
                </td>
                <td>
                    <span>{this.props.article.views}</span>
                </td>
                <td className="hide-on-med-and-down">
                    <span>{this.props.article.clicks}</span>
                </td>
                <td className="hide-on-med-and-down">
                    <span>{this.props.article.attendant}</span>
                </td>
                <td className="hide-on-med-and-down">
                    <span>{this.props.article.brandName}</span>
                </td>
                <td className="items-actions">
                    <i className={this.state.hasPromo > 0 ? "fa fa-asterisk item-action light-green-text text-accent-4" : "fa fa-asterisk item-action grey-text text-lighten-2" } onClick={this._handleTogglePromo.bind(this)} />
                    <i className="fa fa-trash item-action" onClick={this._handleDeleteItem.bind(this)} />
                </td>
            </tr>
        );
    }
}

export default ArticleItemComponent;


// WEBPACK FOOTER //
// ./src/components/ArticleItemComponent.js